module.exports = __webpack_public_path__ + "comparison-offers.png?ccf24bcd503a7753b72a6970789e3860";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparison-offers.png
// module id = 955
// module chunks = 2